<template>
    <v-container>
        <v-row align="center" justify="center">
            <v-col cols="12" xs="12" sm="10" md="5">
                <v-form ref="form" v-model="valid">
                    <v-card class="pt-5" raised>
                        <v-card-title>Reset Password</v-card-title>
                        <v-container class="px-5">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                            v-model="email"
                                            :rules="emailRules"
                                            label="E-mail"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            v-model="password"
                                            :rules="[passwordRules.min]"
                                            label="Password"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            v-model="passwordConfirmation"
                                            :rules="[passwordRules.min,passwordMatches]"
                                            label="Conferma password"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-card-actions>
                                <v-alert
                                        class="w-100"
                                        v-model="alert"
                                        dismissible
                                        color="error"
                                        border="left"
                                        elevation="2"
                                        colored-border>
                                    {{responseError}}
                                </v-alert>
                            </v-card-actions>
                            <v-card-actions>
                                <v-btn color="primary" block @click="submit">Reset</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    name: 'Login',
    data: () => ({
      valid: false,
      email: '',
      password: '',
      passwordConfirmation: '',
      token: null,
      emailRules: [
        v => !!v || 'Email obbligatoria',
        v => /.+@.+/.test(v) || 'Inserire un’e-mail valida',
      ],
      passwordRules: {
        min: v => v.length >= 8 || 'Lunghezza minima 8 caratteri',
      },
      alert: false,
      responseError: ''
    }),
    computed: {
      passwordMatches () {
        return () => (this.password === this.passwordConfirmation) || 'Le password non corrispondono'
      },
    },
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          axios.post('/password/reset/' + this.$route.params.token,
            {
              email: this.email,
              password: this.password,
              password_confirmation: this.passwordConfirmation

            }).then(response => {
            window.location.replace('/')
          }).catch((error) => {
            this.responseError = error.response.data.status
            this.alert = true
          })
        }
      },
    },
    mounted () {
      this.token = this.$route.params.token
      this.email = this.$route.query.email
    }
  }
</script>

<style scoped>

</style>
